import { toast } from "react-toastify";

export function GetCurrentUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
  // let user = localStorage.getItem(STRINGS.AUTH_LOCAL_STORAGE_KEY);
  // if (user === null) {
  // }
  // return JSON.parse(user);
}

export const notifySuccess = (message) => {
  toast.success(message, {
    position: "bottom-right",
    theme: "colored",
  });
};

export const notifyError = (message) => {
  toast.error(message, {
    position: "bottom-right",
    theme: "colored",
  });
};

export const logoutFunc = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("userType");
};

export const formatDate = (dateString) => {
  if (!dateString) {
    return ""; // Return empty string for null dates
  }

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are zero-based
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const amPM = hours >= 12 ? "PM" : "AM";
  hours %= 12;
  hours = hours || 12; // Handle midnight (0 hours)

  const formattedTime = `${hours < 10 ? "0" + hours : hours}:${
    minutes < 10 ? "0" + minutes : minutes
  }:${seconds < 10 ? "0" + seconds : seconds} ${amPM}`;

  return `${day < 10 ? "0" + day : day}-${
    month < 10 ? "0" + month : month
  }-${year}, ${formattedTime}`;
};

export const formatLongDate = (dateString) => {
  if (!dateString) {
    return ""; // Return empty string for null or undefined dates
  }

  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date"; // Return placeholder for invalid dates
  }

  // Format the date
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  // Format the time
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const amPM = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert hour to 12-hour format and handle midnight (0 hours)

  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${amPM}`;

  return `${formattedDate}, ${formattedTime}`;
};
